<div #fileDiv>
    <file-pond #myPond
        [options]="pondOptions"
        (oninit)="pondHandleInit()"
        (onaddfile)="pondHandleAddFile($event)"
        (onremovefile)="pondHandleRemoveFile($event)"
        >
    </file-pond>
    </div>